import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import cx from 'classnames'
import { FlatButton } from 'material-ui'
import css from '../../sitewide/ScheduleBox/styles.css'
import styles from './styles.css'

const AdditionalPatientRow = ({
  openDialog,
  patient: { booking, id, message },
}) => {
  const { doctor, location, start_datetime } = booking
  const formattedApptTime = moment(start_datetime).format('MM/DD/YYYY h:mm a')
  const cellStyles = cx(css.cell, styles.appointmentInfo)
  const truncMsg = message && message.length > 275
    ? message.substr(0, 275).concat('...')
    : message

  return (
    <div>
      <li className={css.bodyRow}>
        <span className={cellStyles}>
          Initial Appointment:
          <span>Doctor:</span>
          {doctor.preferred_name}
          <span>Location: </span>
          {location.name}
          <span>Date and Time: </span>
          {formattedApptTime}
        </span>
        <div>
          <FlatButton
            label="Delete"
            key="delete"
            secondary
            style={{ margin: 'auto 45px auto 0px' }}
            onClick={() => openDialog(id)}
          />
        </div>
      </li>
      {message &&
        <li className={css.bodyRow}>
          <span className={css.cell}>
            Patient Message:
            <span className={styles.patientMessage}>
              {truncMsg}
            </span>
          </span>
        </li>
      }
    </div>
  )
}

AdditionalPatientRow.propTypes = {
  openDialog: PropTypes.func.isRequired,
  patient: PropTypes.object.isRequired,
}

export default AdditionalPatientRow



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingPatients/AdditionalPatientRow.js